<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item v-for="item in routes" :key="item.id" :to="item.link" @click="checkiflogout(item.link)">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            {{ item.text }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="blue-grey darken-4" dark fixed app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>{{
        settings && settings.shop ? settings.shop.name : "Adeton POS"
      }}</v-app-bar-title>
      <v-spacer></v-spacer>

      <h3>(ADMINISTRATOR)</h3>
      <v-btn icon @click="signout()">
        <v-icon>settings_power</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main style="background:#8080802e">
      <v-container grid-list-md text-xs-center  class="fill-height">
        <router-view> </router-view>
      </v-container>
    </v-main>
    <v-footer color="black" app>
      <span class="white--text">&copy; GoPear Technologies (0506340523)</span>
    </v-footer>
  </v-app>
</template>
<style>
@media print {
  /* @page {
            size: A4;
        }
        body * {
            visibility: hidden;
        }
        #printer-content,
        #printer-content * {
            visibility: visible;
        }
        #printer-content {
            position: absolute;
            left: 0;
            top: 0;
        } */

  .noprint {
    display: none;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    drawer: false,
    routes: [
      {
        id: 1,
        icon: "library_books",
        text: "Dashboard",
        link: "/admin",
      },
      {
        id: 2,
        icon: "money",
        text: "Sales",
        link: "/sales",
      },
      {
        id: 4,
        icon: "description",
        text: "Stock Management",
        link: "/e-clerk",
      },

      {
        id: 6,
        icon: "supervised_user_circle",
        text: "Customers",
        link: "/admin/customers",
      },

      {
        id: 7,
        icon: "supervised_user_circle",
        text: "Staffs",
        link: "/admin/users",
      },
      {
        id: 8,
        icon: "money",
        text: "Financials/Accounts",
        link: "/accountant",
      },
      {
        id: 9,
        icon: "message",
        text: "Bulk SMS",
        link: "/admin/sms",
      },

      {
        id: 10,
        icon: "note",
        text: "Reports",
        link: "/reports",
      },
      {
        id: 12,
        icon: "settings",
        text: "Settings",
        link: "/settings",
      },
      {
        id: 11,
        icon: "settings_power",
        text: "Exit",
        link: "/login",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
    }),
  },
  props: {
    source: String,
  },
  created() {
    let c = this;
    this.$store.dispatch("settings/getAll");
  },
 
  methods: {
    signout() {
      var vm = this;

      this.$store.dispatch("Auth/logout");
      vm.$router.push("/");
    },
    setLayout(layout) {
      this.$store.dispatch("Layouts/set_layout", layout);
    },
    checkiflogout(link) {
      if (link == "/login") {
        this.setLayout("simple-layout");
      }
    },
  },
};
</script>